(() => {
  const CARD_SELECTOR = '.product-card, .v-discovery-card, .v-feature-row, .v-best-card';
  const INTERACTIVE_SELECTOR = 'a,button,input,select,textarea,label,form,[role="button"]';

  const bindCards = (root = document) => {
    root.querySelectorAll(CARD_SELECTOR).forEach(card => {
      if (card.dataset.vireltoCardLinkReady === 'true') return;

      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      card.dataset.vireltoCardLinkReady = 'true';
      card.style.cursor = 'pointer';

      card.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (target && target.closest(INTERACTIVE_SELECTOR)) return;

        if (event.metaKey || event.ctrlKey) {
          window.open(productLink.href, '_blank', 'noopener');
          return;
        }

        window.location.assign(productLink.href);
      });
    });
  };

  const init = () => bindCards(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => bindCards(event.target));
})();
